exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.start-date-wrapper .v-menu--inline {\n  width: 100%;\n}\n", ""]);

// exports
